export default {
  user: {},
  loggedIn: false,
  userDataReady: false,
  permissions: [],
  featureFlags: [],
  kioskUser: {},
  kioskPermissions: [],
  invitations: {},
};
